module.exports = __webpack_public_path__ + "static/media/05d.8a2a49e8.svg";